import { useQuery } from 'react-query'
import { FeedSupplierService } from '~/api/services/feedSupplier'
import { FeedProductService } from '~/api/services/feedProduct'
import { ClimaProgramService } from '~/api/services/climaProgram'
import { onError } from '~/utils/helpers'

const getFeedSuppliers = (data) => useQuery(
  'feed-suppliers',
  () => FeedSupplierService.index(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getFeedProducts = (data) => useQuery(
  'feed-products',
  () => FeedProductService.index(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getFeedProductOptionsData = () => useQuery(
  'feed-product-options-data',
  () => FeedProductService.getOptionsData(),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getPurchases = (data) => useQuery(
  ['clima-program-purchases', data],
  () => ClimaProgramService.getPurchases(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getPurchasesOptionsData = () => useQuery(
  'clima-program-purchases-options-data',
  () => ClimaProgramService.getPurchasesOptionsData(),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getPurchasesIndexData = () => useQuery(
  'clima-program-purchases-index-data',
  () => ClimaProgramService.getPurchasesIndexData(),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data?.data
    }
  }
)

const showPurchase = (id) => useQuery(
  ['clima-program-purchase-view', id],
  () => id && ClimaProgramService.showPurchase(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data?.data
    }
  }
)

const getRegistrations = (data) => useQuery(
  ['clima-program-registrations', data],
  () => ClimaProgramService.getRegistrations(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const showRegistration = (id) => useQuery(
  ['clima-program-registration-view', id],
  () => id && ClimaProgramService.showRegistration(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data?.data
    }
  }
)

const editRegistration = (id) => useQuery(
  ['clima-program-registration-edit', id],
  () => id && ClimaProgramService.editRegistration(id),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data?.data
    }
  }
)

const getClimaRegOptionsData = () => useQuery(
  'clima-program-registrations-data',
  () => ClimaProgramService.getClimaRegOptionsData(),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getAcceptTermsFile = () => useQuery(
  'clima-program-accept-terms-file',
  () => ClimaProgramService.getAcceptTermsFile(),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const ClimaProgramQuery = {
  getFeedSuppliers,
  getFeedProducts,
  getFeedProductOptionsData,
  getPurchases,
  getPurchasesOptionsData,
  getPurchasesIndexData,
  showPurchase,
  getRegistrations,
  showRegistration,
  editRegistration,
  getClimaRegOptionsData,
  getAcceptTermsFile
}

export default ClimaProgramQuery
